import { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "./ui/table";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "./ui/pagination";

const Datatable = ({
  limit,
  page,
  setPage,
  columns,
  rows,
  isLoading,
  error,
  total,
  headClass = "",
  cellClass = "",
  rowClass = "",
  onRowClick = () => {},
}) => {
  const totalPages = Math.ceil(total / limit);
  const [selectedRowState, setSelecteRowState] = useState(null);

  return (
    <div className="border rounded-md">
      <Table>
        {/* HEADER */}
        <TableHeader>
          <TableRow>
            {columns.map((col) => (
              <TableHead
                key={col.id}
                // style={{ width: col.width }}
                className={`${headClass} ${col.headClass}`}
              >
                {col.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>

        {/* BODY */}
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell colSpan={columns.length} className="text-center">
                Loading...
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                className="text-center text-destructive"
              >
                Error loading data
              </TableCell>
            </TableRow>
          ) : rows?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={columns.length} className="text-center">
                No data found
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row) => (
              <TableRow
                key={row.id}
                onClick={() => {
                  setSelecteRowState(
                    selectedRowState === row.id ? null : row.id
                  );
                  onRowClick(row);
                }}
                className={`${rowClass}`}
                data-selected={selectedRowState === row.id}
              >
                {columns.map((col) => (
                  <TableCell
                    key={col.id}
                    className={`${cellClass} ${col.cellClass}`}
                    style={{ width: col.width }}
                  >
                    {col.render ? col.render(row) : row[col.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      {/* PAGINATION */}
      {totalPages > 1 && (
        <Pagination className="justify-center py-3">
          <PaginationContent>
            <PaginationItem>
              <PaginationPrevious
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              />
            </PaginationItem>

            {[...Array(totalPages)].map((_, i) => (
              <PaginationItem key={i + 1}>
                <PaginationLink
                  isActive={page === i + 1}
                  onClick={() => setPage(i + 1)}
                >
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}

            <PaginationItem>
              <PaginationNext
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              />
            </PaginationItem>
          </PaginationContent>
        </Pagination>
      )}
    </div>
  );
};

export default Datatable;
